export const styles = {
  box: {
    height: "100vh",
  },

  Mobileimg: {
    width: "300px",
    border: "1px solid green",
  },
};
